














import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SurveyModel } from "survey-core";
import { QuestionRowModel } from "survey-core";
import { BaseVue } from "./base";
import { Base } from "survey-core";

@Component
export class Row extends BaseVue {
  @Prop() row: QuestionRowModel;
  @Prop() css: any;
  @Prop() survey: SurveyModel;

  get elements(): Array<any> {
    return this.row.visibleElements;
  }

  protected getModel(): Base {
    return this.row;
  }
  private lazyRenderingTimeout: ReturnType<typeof setTimeout> | undefined = undefined;

  protected onMounted() {
    if (!!this.row) {
      if (!this.row.isNeedRender) {
        var rowContainerDiv = this.$el;
        this.lazyRenderingTimeout = setTimeout(() => {
          this.row.startLazyRendering(rowContainerDiv as HTMLElement);
        }, 10);
      }
    }
  }
  beforeDestroy() {
    clearTimeout(this.lazyRenderingTimeout);
    if (!!this.row && !this.row.isDisposed) {
      this.row.isNeedRender = !this.row.isLazyRendering();
    }
  }
}
Vue.component("survey-row", Row);
export default Row;
